export function useCheckIntercomTourExists(): {
  checkIntercomTourExists: () => boolean;
} {
  function checkIntercomTourExists() {
    const element = document.getElementById("intersection-container");

    return element ? element.tagName.toLowerCase() === "div" : false;
  }

  return { checkIntercomTourExists };
}
